import { useState } from "react";
import p2 from "~/assets/java/p2@3x.png";
import p3 from "~/assets/java/p3@3x.png";
import p4 from "~/assets/java/p4@3x.png";
import p6 from "~/assets/java/p6@3x.png";
import p10 from "~/assets/java/p10@3x.png";
import p19 from "~/assets/fullstack/p11@3x.png";
import p20 from "~/assets/fullstack/p12@3x.png";
import p21 from "~/assets/java/p21@3x.png";
import p22 from "~/assets/java/p22@3x.png";
import p23 from "~/assets/java/p23@3x.png";
import p24 from "~/assets/java/p24@3x.png";
import p28 from "~/assets/java/p28@3x.png";
import p29 from "~/assets/java/p29@3x.png";

import SiteLayout from "components/layout/SiteLayout";

import { Collapse } from "antd";
const { Panel } = Collapse;

const Page = () => {
  const [active, setActive] = useState<string>("left");
  const [accordions, setAccordions] = useState<boolean[]>([]);
  const toggleState = (i: number) => {
    const newAccordions = [...accordions];
    newAccordions[i] = !newAccordions[i];
    setAccordions(newAccordions);
  };
  return (
    <SiteLayout largeContainer="true">
      <div className="java-wrapper">
        <div className="block1">
          <div className="content">
            <div className="left">
              <div className="text">Java全栈项目</div>
              <div className="text">训练营</div>
              <img className="p2" src={p2.src} />
            </div>
          </div>
          <img src={p3.src} className="p3" />
        </div>
        <div className="block2">
          <div className="content">
            <div className="title-w">
              <img src={p4.src} />
              <div className="title">适合学员</div>
              <img src={p4.src} />
            </div>
            <div className="mp-list-content">
              <div className="list-w">
                <div className="item">
                  <div>针对没有项目经验，</div>
                  <div>有编程基础的IT、</div>
                  <div>CS在校生和毕业生</div>
                </div>
                <div className="item">
                  <div>国内有IT工作经验，</div>
                  <div>无本地经验的新移民</div>
                </div>
                <div className="item">
                  <div> 想要获取商业</div>
                  <div>实战项目经验，积</div>
                  <div>累IT人脉的学生</div>
                </div>
                <div className="item item-last">
                  <div>IT毕业生想要寻求</div>
                  <div>海外第一份IT工作</div>
                </div>
              </div>
              <div className="item-long">
                <div>05</div>
                技术掌握不全面，只懂java或者只懂前端的同学
              </div>
              <img src={p6.src} className="mid" />
            </div>
            <div className="pc-list-content">
              <div className="list-w">
                <div className="item">
                  <div>01</div>
                  针对没有项目经验，有编程基础的IT、CS在校生和毕业生
                </div>
                <div className="item">
                  <div>02</div>国内有IT工作经验，无本地经验的新移民
                </div>
                <div className="item">
                  <div>03</div>想要获取商业实战项目经验，积累IT人脉的学生
                </div>
                <div className="item">
                  <div>04</div>IT毕业生想要寻求海外第一份IT工作
                </div>
                <div className="item">
                  <div>05</div>技术掌握不全面，只懂java或者只懂前端的同学
                </div>
              </div>
              <img src={p10.src} className="p10" />
            </div>
          </div>
        </div>
        <div className="block3">
          <div className="content">
            <div className="title-w">
              <img src={p4.src} />
              <div className="title">服务介绍</div>
              <img src={p4.src} />
            </div>
            <div className="list-w">
              <div className="item item1">
                <div className="text1">1+2模式</div>
                <div className="text2">
                  1个月课程培训+2个月的项目实习；包含1个人项目+1个团队项目
                </div>
              </div>
              <div className="item item2">
                <div className="text1">终生免费视频学习</div>
                <div className="text2">
                  一次付费，终生学习，且享有该课程后续更新内容。
                </div>
              </div>
              <div className="item item3">
                <div className="text1">多人对你负责</div>
                <div className="text2">
                  导师+助教+班主任，学员随时有问题就问
                </div>
              </div>
              <div className="item item4">
                <div className="text1">小班上课+</div>
                <div className="text1">免费修改简历+内推</div>
                <div className="text2">
                  一个班不超过15人，老师一对一帮忙修改简历，合作公司直推+内推
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block4">
          <div className="content">
            <div className="title-w">
              <img src={p4.src} />
              <div className="title">课程介绍</div>
              <img src={p4.src} />
            </div>
            <Collapse ghost>
              <Panel
                className={`panel ${!accordions[0] && "without-line"}`}
                showArrow={false}
                key={0}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(0)}>
                    <div>阶段1：夯实React基础</div>
                    {accordions[0] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="item">
                    <p>1. react.js 简介</p>
                    <p>2. jsx 模版语法及 babel 编译配置</p>
                    <p>3. 事件/条件渲染/列表渲染等基础用法</p>
                    <p>4. react.js 组件化及生命周期</p>
                    <p>5. refs 及 React API 详解</p>
                    <p>6. 高阶组件用法及封装</p>
                    <p>7. react hook 用法详解</p>
                    <p>8. 异步组件/suspense 等新版内容介绍</p>
                  </div>
                  <div className="item">
                    <p>9. redux 状态管理详解</p>
                    <p>10. mobx 状态管理详解</p>
                    <p>11. mobx 与 redux 区别</p>
                    <p>12. 前端路由 router 原理及表现</p>
                    <p>13. React-router详解</p>
                    <p>14. 服务端渲染 & 异步组件 & spa</p>
                    <p>15. 实现一个 react 组件库</p>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[1] && "without-line"}`}
                showArrow={false}
                key={1}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(1)}>
                    <div>阶段2：Java进阶之路</div>
                    {accordions[1] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="item">
                    <p className="title">夯实基础</p>
                    <p>1. 数据类型、变量和常量的使用</p>
                    <p>2. 选择结构的执行流程与应用</p>
                    <p>3. while、do-while和for三种循环结构的使用</p>
                    <p>4. break和continue语句的特点及应用</p>
                    <p>5. 如何进行程序的调试，debug的使用</p>
                    <p>6. 一维数组和二维数组的应用</p>
                    <p>7. Java自定义方法和方法调用</p>
                    <p>8. 类的定义和对象的创建</p>
                    <p>9. 理解构造方法的概念，并进行应用</p>
                    <p>10. 封装的特点，应用代码实现程序的封装</p>
                    <p>11. 包的创建和导入</p>
                  </div>
                  <div className="item">
                    <p className="item-mt">12. 静态变量和静态方法的应用</p>
                    <p>13. 继承的概念和特点，父类和子类的概念及应用</p>
                    <p>14. 方法重写的特点及使用</p>
                    <p>15. 通过super关键字对父类方法进行调用</p>
                    <p>16. 所有类的父类Object类的使用</p>
                    <p>17. 使用final关键字定义最终类</p>
                    <p>18. 现阶段开发中涉及到的常用注解的使用</p>
                    <p>19. 单例模式的定义和使用</p>
                    <p>20. 懒汉模式和饿汉模式的特点及代码实现</p>
                    <p>21. git、maven的使用</p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">函数式编程</p>
                    <p>1. 函数式编程概述</p>
                    <p>2. lambda表达式</p>
                    <p>3. Stream以及常见的基本函数</p>
                    <p>4. 常用类（Optional、CompletableFuture）</p>
                    <p>5. lambda表达式与设计模式</p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">并发编程基础</p>
                    <p>1. 并发编程的原子性、可见性和有序性</p>
                    <p>2. 使用线程之间协调的常用方法</p>
                    <p>3. volatile的原理和使用场景</p>
                    <p>4. ThreadGroup的原理和使用场景</p>
                    <p>5. Daemon的原理和使用场景</p>
                    <p>
                      6.
                      探究Synchronized锁的优化策略（加锁流程、偏向锁、轻量级锁、自旋锁、重量级锁、锁消除）
                    </p>
                    <p>7. CAS的执行流程及Atomic*的原子类</p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">JDK9-17 新特性</p>
                    <p>1. Process API</p>
                    <p>2. 加强的字符串API</p>
                    <p>3. G1与ZGC</p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">MySQL </p>
                    <p>1. SQL基础</p>
                    <p>2. 一条SQL查询语句是如何执行的</p>
                    <p>3. 锁与事务隔离</p>
                    <p>4. 深入检出索引</p>
                    <p>5. SQL优化</p>
                    <p>6. mysql是如何保证数据不丢的</p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">SpringBoot </p>
                    <p>1. 概述SpringBoot在企业级的应用场景</p>
                    <p>
                      2.
                      通过maven项目创建SpringBoot项目以及通过脚手架创建SpringBoot项目
                    </p>
                    <p>3. 探究SpringBoot的版本依赖管理</p>
                    <p>
                      4. SpringBoot中Start的含义和作用，并以Web
                      Start为例加深理解
                    </p>
                    <p>5. SpringBoot中的自动配置以及默认的包扫描路径</p>
                    <p>6. 默认配置项以及配置对应的配置文件类</p>
                    <p>7. 实现自定义配置文件绑定以及开启配置默认值提示</p>
                    <p>
                      8.
                      yaml常用语法介绍（基本语法、数据类型、字面量、对象、集合、数组）
                    </p>
                    <p>
                      9.
                      常用注解解析（@Configuration、@ComponentScan、@Bean、@Import、@Condition、@ImportResource）
                    </p>
                  </div>
                  <div className="item">
                    <p className="title title-mt">MyBatis </p>
                    <p>1. 通过JDBC、Hibernate和MyBatis实现数据库访问</p>
                    <p>
                      2.
                      select查询操作，包括自动映射、基础入参查询、map类型入参查询、注解方式入参查询、JavaBean入参方式查询
                    </p>
                    <p>3. insert插入操作，包括普通插入、主键回填插入</p>
                    <p>4. update更新操作</p>
                    <p>5. delete删除操作</p>
                    <p>6. $与#的区别，理解什么是SQL注入</p>
                    <p>7. 级联方式：association、collection</p>
                    <p>8. MyBatis的一级缓存和二级缓存</p>
                    <p>
                      9.
                      MyBatis中的动态SQL（if、test、choose、when、otherwise、trim、where、set、foreach、concat、bind）
                    </p>
                    <p>10. 代理（静态代理、JDK动态代理、CGLIB）</p>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[2] && "without-line"}`}
                showArrow={false}
                key={2}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(2)}>
                    <div>阶段3：个人Chatgpt商业站</div>
                    {accordions[2] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="item">
                    <p>1. OpenAI接口api解析及基于AccessToken的代理模式</p>
                    <p>2. 主要组件讲解</p>
                    <p>3. 对话系统的实现</p>
                    <p>4. 页面响应式</p>
                    <p>5. 引入个性化UI</p>
                    <p>6. 登录系统的前后端接入（MongoDB Online）</p>
                    <p>7. token购买及相关逻辑</p>
                  </div>
                  <div className="item">
                    <p>8. 实现邀请码功能</p>
                    <p>9. 实现提示词词库</p>
                    <p>10. 邮件通知系统</p>
                    <p>11. 项目Vercel部署及配置</p>
                    <p>12. Nginx配置、域名购买、域名配置</p>
                    <p>13. 防封策略</p>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[3] && "without-line"}`}
                showArrow={false}
                key={3}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(3)}>
                    <div>阶段4：企业级商业项目</div>
                    {accordions[3] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="item">
                    <p className="title">电商项目</p>
                    <p className="p-item">
                      <span>【项目设计阶段】</span>
                      <span>需求分析，架构设计，详细设计，工程框架搭建</span>
                    </p>
                    <p className="p-item p-mt">
                      <span>【文件微服务模块】</span>
                      <span>
                        搭建文件存储服务，实现上传商品相关图片及文件的上传、下载、加速图片展示、自动生成图片缩率图等功能；
                      </span>
                    </p>
                    <p className="p-item p-mt">
                      <span>【权限及安全微服务模块】</span>
                      <span>
                        登录授权、权限验证、会员权限级别管理等功能开发；
                      </span>
                    </p>
                    <p className="p-item p-mt">
                      <span>【秒杀微服务模块】</span>
                      <span>秒杀的需求场景分析以及详细设计；</span>
                      <span>针对可能遇到的场景的思考及优化分析；</span>
                      <span>通过 jmeter 对当前的高频接口进行压测验证；</span>
                      <span>并基于验证结果来优化解决超卖问题；</span>
                      <span>性能优化；</span>
                      <span>如何保证电商项目集群的高可用性？</span>
                      <span>如何通过arthas优化服务性能？</span>
                    </p>
                  </div>
                  <div className="item">
                    <p className="p-item p-mt p-mt-big">
                      <span>【商品微服务模块】</span>
                      <span>商品的发布、删除及商品的搜索功能开发；</span>
                    </p>
                    <p className="p-item p-mt">
                      <span>【用户微服务模块】</span>
                      <span>
                        用户登录、注册、会员管理、SVIP模块等功能开发；
                      </span>
                    </p>
                    <p className="p-item p-mt p-mt-big-2">
                      <span>【订单微服务模块】</span>
                      <span>
                        包括微信支付流程，订单创建及支付的分布式事务开发；
                      </span>
                    </p>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
        <div className="block5">
          <div className="content">
            <div className="title-w">
              <img src={p4.src} />
              <div className="title">项目亮点</div>
              <img src={p4.src} />
            </div>
            <div className="list-w">
              <div className="item">
                <img src={p21.src} />
                <div>完善的项目流程，包</div>
                <div>含：需求-设计-接口-</div>
                <div>代码-测试-部署</div>
              </div>
              <div className="item">
                <img src={p22.src} />
                <div>团队协作，企业级</div>
                <div>真实职场项目</div>
              </div>
              <div className="item">
                <img src={p23.src} />
                <div>写进简历提升</div>
                <div>Offer筹码</div>
              </div>
              <div className="item">
                <img src={p24.src} />
                <div>班主任督促检查</div>
                <div>每周项目进度</div>
              </div>
            </div>
          </div>
        </div>
        <div className="block6">
          <div className="content">
            <div className="title-w">
              <img src={p28.src} />
              <div className="title title-sm">你将会获得</div>
              <img src={p28.src} />
            </div>
            <div className="list-w">
              <div className="item">
                <div>扎实的基础知识，努力吊打面试官</div>
                <div>企业级实战项目经验，丰富你的简历</div>
                <div>简历指导与简历修改</div>
                <div>背景调查证明</div>
                <div>电鸭全球优质远程、全职、兼职⼯作机会，⽆限次内推服务</div>
              </div>
              <div className="item">
                <div>优秀学员, 电鸭导师直接挖人</div>
                <div>课程所有资料、源码均会分享</div>
                <div>所有直播均有录播，且享有该课程后续更新观看权限</div>
                <div>结识⼀群和你有相同⽬标，⼀起奋⽃的⼩伙伴</div>
              </div>
              <img src={p29.src} />
            </div>
          </div>
        </div>
        <div className="block7">
          <div className="content">
            <div className="title-w">
              <img src={p4.src} />
              <div className="title title-sm">课程导师</div>
              <img src={p4.src} />
            </div>
            <div className="list-w">
              <div className="item">
                <div className="name">Muse</div>
                <div className="text">
                  毕业于北航，曾任职于阿里、百度、微软等公司
                </div>
                <div className="text">完成多个系统从0到1的系统设计</div>
                <div className="text">
                  具备高并发，高复杂度等大型系统的架构能力
                </div>
                <div className="text">10年以上的互联网研发经验</div>
              </div>
              <div className="item">
                <div className="name">Allan</div>
                <div className="text">曾任职于字节、亚马逊等公司</div>
                <div className="text">
                  擅长协同富文本编辑器及视频编辑器的性能优化及AI领域
                </div>
                <div className="text">
                  曾管理30余人团队，在技术体系建设，难点攻坚，历史包袱重构方面有丰富实践经验。
                </div>
              </div>
              <div className="item item-last">
                <div className="name">SAM</div>
                <div className="text text-1">曾任职于字节、亚马逊等公司</div>
                <div className="text text-1">
                  7年前端经验，从产品经理3个月零基础自学转行前端。
                </div>
                <div className="text text-1">
                  擅长协同富文本编辑器及视频编辑器的性能优化及AI领域，深入了解前端各类技术框架，拥有稳定性建设和性能、体验优化的丰富经验。
                </div>
                <div className="text text-1">
                  管理30余人团队，在技术体系建设，难点攻坚，历史包袱重构方面有丰富实践经验。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};
export default Page;
